<template>
    <modal
        :show="show"
        :title="modalTitle"
        :saveButton="{
            visible: false
        }"
        :cancelButton="{
            visible: false
        }"
        size="small"
        :needHeader="true"
        :needFooter="false"
        :relativeBackdrop="true"
        :centered="true"
        :contentCentered="true"
        class="modal-upload-file"
        @close="onClose"
    >
        <form class="" autocomplete="off" @submit.prevent="">
            <div role="body" class="d-flex">
                <div class="" style="flex-column">
                    <div class="file-upload-wrapper" >
                        <div class="card card-body view file-upload" :class="{'has-preview': hasFiles, 'has-error': hasErrors}">
                            <div class="card-text file-upload-message">
                                <i class="fas fa-cloud-upload-alt"></i>
                                <p v-html="txtImport"></p>
                                <p class="file-upload-error">{{ msgError }}</p>
                            </div>
                            <div class="mask rgba-stylish-slight"></div>
                            <div class="file-upload-errors-container">
                                <ul>
                                    <li v-for="(error, idx) in importErrors" :key="idx">{{ error }}</li>
                                </ul>
                            </div>
                            <input type="file"
                                id="input-file"
                                class="file_upload"
                                @change="onUploadFile"
                                :accept="allowedFileTypes"
                                data-max-file-size="2M">

                            <button type="button"
                                class="btn btn-sm btn-danger waves-effect waves-light"
                                @click.stop="onRemoveFile">
                                Remove<i class="far fa-trash-alt ml-1"></i>
                            </button>
                            <div class="file-upload-preview">
                                <span class="file-upload-render">
                                    <i class="fas fa-file"></i>
                                    <span class="file-upload-extension">{{ fileExtension }}</span>
                                </span>
                                <div class="file-upload-infos">
                                    <div class="file-upload-infos-inner">
                                        <p class="file-upload-filename">
                                            <span class="file-upload-filename-inner">{{ fileName }}</span>
                                        </p>
                                        <p class="file-upload-infos-message" v-html="txtPreviewUpload"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <slot></slot>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>

import Modal from '@/app/shared/components/modals/Modal';
import GlobalMixin from '@/app/shared/mixins/global';
import { isFunction, isObject, isArray, isString, fileSizeParser, humanFileSize } from '@config/utils';

export default {
    name: 'ModalImportFile',
    mixins: [
        GlobalMixin,
    ],
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
        },
        txtImport: {
            type: String,
            default: 'Arraste e solte um ficheiro aqui ou clique', //'Drag and drop a file here or click',
        },
        txtPreviewUpload: {
            type: String,
            default: 'Arraste e solte ou clique para substituir', //'Drag and drop or click to replace',
        },
        txtError: {
            type: String,
            default: 'Ooops, algo errado aconteceu.', //'Ooops, something wrong happended.',
        },
        genericError: {
            type: String,
            default: 'O ficheiro não é válido', //'The file is not valid',
        },
        allowedFileTypes: {
            type: String,
            default: '*',
        },
        maxFileSize: {
            type: String|Number,
            default: 1 * 1024 * 1024, // 1MB
        },
        fileValidation: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            show: false,
            modalTitle: null,
            importErrors: [],
            files: [],
        }
    },
    mounted() {
        this.modalTitle = this.title;
    },
    computed: {
        msgError() {
            return this.txtError;
        },
        hasFiles() {
            return this.files && this.files.length;
        },
        hasErrors() {
            return this.importErrors && this.importErrors.length;
        },
        file() {
            return this.hasFiles ? this.files[0] : null;
        },
        fileName() {
            return this.file ? this.file.name : null;
        },
        fileExtension() {
            return this.fileName ? this.fileName.split('.').pop() : null;
        },
    },
    methods: {
        open: function(params) {
            this.reset();
            this.show=true;
        },
        closeModal: function() {
            this.show=false;
        },
        onClose: function() {
            this.callCancel();
        },
        onUploadFile: function(e) {
            this.importErrors = [];
            // create a new array with our files
            const files = this.files = Object.keys(e.target.files).map((i) => e.target.files[i]);
            if(files) {
                let promises = [];

                files.forEach(file => {
                    const promise = new Promise(async (resolve, reject) => {
                        let errors = [];
                        if(!this.checkFileType(file)){
                            errors.push(`File is not allowed to upload! You can only upload the following files (${this.allowedFileTypes})`);
                        }
                        if(!this.checkFileSize(file)) {
                            errors.push(`File to big (${humanFileSize(file.size)})! Max file size is (${this.maxFileSize})`);
                        }
                        if(isFunction(this.fileValidation)) {
                            await Promise.resolve(this.fileValidation(file)).then((result) => {
                                let _errors = [];
                                if(isObject(result) && result.errors){
                                    if(!isArray(result.errors)){
                                        _errors.push(result.errors);
                                    }else{
                                        _errors = result.errors;
                                    }
                                }
                                else if(isArray(result)) {
                                    _errors = _errors.concat(result);
                                }
                                else if(isString(result)) {
                                    _errors.push(result);
                                }
                                else if(!!!result) {
                                    _errors.push(this.genericError);
                                }
                                errors = errors.concat(_errors);
                            });
                        }

                        resolve(errors);
                    });
                    promises.push(promise);
                });

                Promise.all(promises).then((responses) => {
                    responses.forEach((errors) => {
                        this.importErrors = this.importErrors.concat(errors);
                    });

                    if(this.hasErrors) {
                        this.removeFiles();
                        return;
                    }
                    this.callCallback();
                });
            }
        },
        onRemoveFile: function(index = 0) {
            this.files.splice(index, 1);
        },
        removeFiles: function() {
            let i = this.files.length
            while (i--) {
                this.files.splice(i, 1);
            }
        },
        callCallback: function() {
            this.$emit('imported', {file: this.file});
            this.closeModal();
        },
        callCancel: function() {
            this.closeModal();
            if(this.fn_cancel){
                this.fn_cancel();
            }
        },
        reset: function() {
            this.removeFiles();
            this.importErrors = [];
        },
        checkFileType: function(file) {
            if (!file.type && file.size%4096 === 0) return false;
            if(this.allowedFileTypes == '*') return true;

            let extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

            let allowedTypes = this.allowedFileTypes.replace(' ', '').split(",");
            let allowedTypesLower = [];

            for (let i = allowedTypes.length - 1; i >= 0; i--) {
                if(allowedTypes[i].indexOf(".") != -1){
                    if(file.type.match(allowedTypes[i]) !== null) return true;
                }
                allowedTypesLower.push(allowedTypes[i].toLowerCase());
            }

            return allowedTypesLower.includes(extension);
        },
        checkFileSize: function(file){
            return file.size < fileSizeParser(this.maxFileSize);
        },
    }
}
</script>

<style scoped lang="scss">
    .view .mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-attachment: fixed;
    }
    .rgba-stylish-slight {
        background-color: rgba(62,69,81,0.1);
    }

    .file-upload {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        height: 200px;
        padding: 5px 10px;
        font-size: 1rem;
        text-align: center;
        color: #ccc;

        i {
            font-size: 3rem;
        }

        .mask.rgba-stylish-slight {
            opacity: 0;
            -webkit-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;
        }

        &:hover .mask.rgba-stylish-slight {
            opacity: .8;
        }
    }
    .file-upload-wrapper .card.card-body {
        .file-upload-message {
            position: relative;
            // top: 50px;
            // -webkit-transform: translateY(-50%);
            // -ms-transform: translateY(-50%);
            // transform: translateY(-50%);

            p {
                margin: 5px 0 0;

                &.file-upload-error {
                    color: #f34141;
                    font-weight: 700;
                    display: none;
                }
            }
        }

        .file-upload-errors-container {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background: rgba(243, 65, 65, .8);
            text-align: left;
            visibility: hidden;
            opacity: 0;
            -webkit-transition: visibility 0s linear .15s, opacity .15s linear;
            -o-transition: visibility 0s linear .15s, opacity .15s linear;
            transition: visibility 0s linear .15s, opacity .15s linear;

            ul {
                margin: 0;
                padding: 0;

                li {
                    margin-left: 1.5rem;
                    padding-bottom: 0.5rem;
                    color: #fff;
                    font-weight: 700;
                }
            }
        }

        .file-upload-preview {
            display: none;
            position: absolute;
            z-index: 1;
            background-color: #fff;
            padding: 5px;
            width: 100%;
            height: 100%;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            overflow: hidden;
            text-align: center;

            .file-upload-render {
                i {
                    font-size: 80px;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    position: absolute;
                    color: #777;
                }
                .file-upload-extension {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    margin-top: 10px;
                    text-transform: uppercase;
                    font-weight: 900;
                    letter-spacing: -.03em;
                    font-size: 1rem;
                    color: #fff;
                    width: 42px;
                    white-space: nowrap;
                    overflow: hidden;
                    -o-text-overflow: ellipsis;
                    text-overflow: ellipsis;
                }
            }

            .file-upload-infos {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                z-index: 3;
                background: rgba(0, 0, 0, .7);
                opacity: 0;
                -webkit-transition: opacity .15s linear;
                -o-transition: opacity .15s linear;
                transition: opacity .15s linear;

                .file-upload-infos-inner {
                    position: absolute;
                    top: 50%;
                    -webkit-transform: translate(0, -40%);
                    -ms-transform: translate(0, -40%);
                    transform: translate(0, -40%);
                    -webkit-backface-visibility: hidden;
                    backface-visibility: hidden;
                    width: 100%;
                    padding: 0 20px;
                    -webkit-transition: all .2s ease;
                    -o-transition: all .2s ease;
                    transition: all .2s ease;

                    p {
                        padding: 0;
                        margin: 0;
                        position: relative;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        -o-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        color: #fff;
                        text-align: center;
                        line-height: 25px;
                        font-weight: 700;

                        &.file-upload-infos-message {
                            margin-top: 15px;
                            padding-top: 15px;
                            font-size: 12px;
                            position: relative;
                            opacity: .5;

                            &::before {
                                content: "";
                                position: absolute;
                                top: 0;
                                left: 50%;
                                -webkit-transform: translate(-50%, 0);
                                -ms-transform: translate(-50%, 0);
                                transform: translate(-50%, 0);
                                background: #fff;
                                width: 30px;
                                height: 2px;
                            }
                        }
                    }
                }
            }
        }

        input {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
            cursor: pointer;
            z-index: 5;
        }

        .btn.btn-sm.btn-danger {
            display: none;
            position: absolute;
            opacity: 0;
            z-index: 7;
            top: 10px;
            right: 10px;
            -webkit-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;

            i {
                font-size: 1rem;
            }
        }

        &.has-error {
            border-color: #f34141;

            .file-upload-message .file-upload-error {
                display: block;
            }

            &:hover .file-upload-errors-container {
                visibility: visible;
                opacity: 1;
                -webkit-transition-delay: 0s;
                -o-transition-delay: 0s;
                transition-delay: 0s;
            }
        }

        &.has-preview {
            .btn.btn-sm.btn-danger,
            .file-upload-preview {
                display: block;
            }
        }

        &:hover {
            .btn.btn-sm.btn-danger,
            .file-upload-preview .file-upload-infos {
                opacity: 1;
                .file-upload-infos-inner {
                    margin-top: -5px;
                }
            }
        }
    }

</style>